import React, { createContext, useState, useContext, useEffect } from 'react';

// テーマコンテキストの作成
const ThemeContext = createContext();

// カスタムフックの作成
export const useTheme = () => {
  return useContext(ThemeContext);
};

// プロバイダーコンポーネント
export const ThemeProvider = ({ children }) => {
  // ローカルストレージから初期テーマを取得するか、デフォルトでライトモードに設定
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
  });

  // テーマ変更時の処理
  useEffect(() => {
    // data-theme属性をhtmlまたはroot要素に設定
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
    
    // 互換性のためにbody要素にもクラスを適用
    document.body.classList.toggle('dark-theme', isDarkMode);
    
    // ローカルストレージにテーマを保存
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  // テーマを切り替える関数
  const toggleTheme = () => {
    setIsDarkMode(prevMode => !prevMode);
  };

  // コンテキストの値
  const value = {
    isDarkMode,
    toggleTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}; 